module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_02_american-village-8eeff0b0dd5d7a364a906dec8e6c8ce0.jpg";